var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_4473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80281 58.3137C-4.17206 39.0974 3.31958 15.4333 22.5359 5.45842C38.0068 -2.5723 56.3607 0.718386 68.1329 12.3341",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4268 22.3091C85.1662 41.6458 77.386 65.2166 58.0493 74.956C42.4815 82.7972 24.1691 79.2825 12.5397 67.5239",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49614 58.48L6.47126 59.593L7.47829 55.5901",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6923 22.15L74.7194 21.0289L73.7043 25.0298",
    stroke: "#73767D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7397,
    y: 25.3887,
    width: 38.9656,
    height: 7.17374,
    fill: "#73767D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3212 37.7756V31.0826V28.3275V23.4201C55.3212 21.3072 53.6029 19.5889 51.49 19.5889H18.9243C16.8113 19.5889 15.093 21.3072 15.093 23.4201V28.3275V31.0826V44.492C15.093 46.605 16.8113 48.3233 18.9243 48.3233H42.5792",
    stroke: "#73767D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.527 50.6564H17.9933C17.8735 50.6564 17.7566 50.6455 17.6387 50.6387L18.5689 55.8736C18.7526 56.908 19.3273 57.8078 20.1878 58.408C20.8549 58.8746 21.6319 59.1173 22.4286 59.1173C22.6584 59.1173 22.8922 59.0966 23.1241 59.0554L44.7358 55.329",
    stroke: "#73767D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5544,
    cy: 38.897,
    r: 3.122,
    transform: "rotate(-90 22.5544 38.897)",
    stroke: "#73767D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.8478,
    cy: 38.8975,
    r: 3.122,
    transform: "rotate(-90 25.8478 38.8975)",
    stroke: "#73767D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6261 60.9504L67.1184 64.5852",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6357 52.1768L71.048 52.3461",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2314 64.0845L53.9813 66.513",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5272 60.1165C59.7837 60.1165 64.8555 55.0447 64.8555 48.7882C64.8555 42.5318 59.7837 37.46 53.5272 37.46C47.2708 37.46 42.199 42.5318 42.199 48.7882C42.199 55.0447 47.2708 60.1165 53.5272 60.1165ZM50.9587 54.9823C51.6459 55.2355 52.3693 55.3621 53.1289 55.3621V56.2121C53.1289 56.4518 53.3232 56.6461 53.5629 56.6461C53.8026 56.6461 53.9969 56.4518 53.9969 56.2121V55.3621C54.5153 55.3259 55.0036 55.2174 55.4617 55.0366C55.9199 54.8558 56.3177 54.6086 56.6553 54.2951C57.0049 53.9817 57.2822 53.6079 57.4872 53.1739C57.6921 52.7399 57.7946 52.2516 57.7946 51.7091C57.7946 51.1183 57.6861 50.624 57.4691 50.2262C57.2641 49.8283 56.9808 49.4968 56.6191 49.2316C56.2695 48.9543 55.8656 48.7252 55.4075 48.5444C54.9493 48.3635 54.4791 48.1947 53.9969 48.038V43.535C54.4671 43.535 54.9011 43.6375 55.299 43.8425C55.4553 43.9183 55.6024 44.0071 55.7401 44.109C56.0891 44.3672 56.5873 44.4238 56.9085 44.1318C57.241 43.8295 57.2783 43.308 56.9201 43.0365C56.6215 42.8101 56.2861 42.6266 55.9138 42.4861C55.2869 42.245 54.6479 42.1245 53.9969 42.1245V41.3649C53.9969 41.1252 53.8026 40.9309 53.5629 40.9309C53.3232 40.9309 53.1289 41.1252 53.1289 41.3649V42.1245C52.6587 42.1606 52.2066 42.2752 51.7725 42.4681C51.3385 42.6489 50.9527 42.896 50.6151 43.2095C50.2896 43.5109 50.0304 43.8726 49.8375 44.2946C49.6446 44.7165 49.5482 45.1807 49.5482 45.687C49.5482 46.2296 49.6446 46.7058 49.8375 47.1157C50.0304 47.5136 50.2896 47.8572 50.6151 48.1465C50.9527 48.4359 51.3385 48.683 51.7725 48.888C52.2066 49.0809 52.6587 49.2376 53.1289 49.3581V53.9515C52.6104 53.9274 52.1101 53.7948 51.6279 53.5537C51.4566 53.4659 51.2989 53.3668 51.1549 53.2566C50.7645 52.958 50.1931 52.8661 49.8226 53.189C49.5045 53.4662 49.447 53.9502 49.756 54.2375C50.1089 54.5657 50.5099 54.814 50.9587 54.9823ZM51.7002 44.2765C52.0619 43.8907 52.5381 43.6435 53.1289 43.535V47.8029C52.8516 47.6944 52.5924 47.5859 52.3512 47.4774C52.1222 47.3568 51.9172 47.2182 51.7364 47.0614C51.5676 46.9047 51.4289 46.7178 51.3204 46.5008C51.224 46.2838 51.1758 46.0186 51.1758 45.7051C51.1758 45.1264 51.3506 44.6502 51.7002 44.2765ZM55.5341 53.2463C55.1241 53.6441 54.6118 53.8792 53.9969 53.9515V49.5932C54.2742 49.6776 54.5394 49.7801 54.7926 49.9007C55.0578 50.0092 55.2929 50.1478 55.4979 50.3166C55.7028 50.4854 55.8656 50.6904 55.9862 50.9315C56.1067 51.1726 56.167 51.4559 56.167 51.7814C56.167 52.3601 55.956 52.8484 55.5341 53.2463Z",
    fill: "#31B59F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_4473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5 0.166504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseSync);
export default __webpack_public_path__ + "static/media/expense-sync.90dca7dfa74ed81abaa91ce9e3649fc2.svg";
export { ForwardRef as ReactComponent };